import * as React from 'react';
import { AddNewCardButton, ErrorMessageContainer } from './parts';

interface IAddNewCardProps {
  buttonRef?: React.Ref<HTMLDivElement>;
}

export const AddNewCardContainer: React.FC<IAddNewCardProps> = ({ buttonRef }) => {
  return (
    <>
      <ErrorMessageContainer />
      <AddNewCardButton buttonRef={buttonRef} />
    </>
  );
};
